import {cUtil}       from './../../../functions/util';
import {getPrice} from '../../../objects/price/get-price';
import {cProductItemPlatter} from '../platter/product-item-platter';

interface AmountDataFull extends AmountData {
  isOnSale              : boolean;
  isIndvidualPrice      : boolean;
  priceToDate           : string;
  sellingUnitPrice      : number;
  sellingUnitPriceLabel : string;
  totalPrice            : number;
  totalAmountKg         : number;
  totalAmountLabel      : string;
}

export class cProductItemAmounts implements DateFieldTop {

  fieldset_amount            = document.createElement('fieldset');
  label_amount               = document.createElement('label');
  div_amount_wrapper         = document.createElement('div');
  input_amount               = document.createElement('input');
  span_amount                = document.createElement('span');
  div_amount_error           = document.createElement('div');

  fieldset_amountSelect      = document.createElement('fieldset');
  label_amountSelect         = document.createElement('label');
  select_amountSelect        = document.createElement('select');
  div_amountSelect_error     = document.createElement('div');
  
  fieldset_weightPerPiece    = document.createElement('fieldset');
  label_weightPerPiece       = document.createElement('label');
  div_weightPerPiece_wrapper = document.createElement('div');
  span_weightPerPiece        = document.createElement('span');
  input_weightPerPiece       = document.createElement('input');
  div_weightPerPiece_error   = document.createElement('div');
  
  fieldset_sellingUnit       = document.createElement('fieldset');
  label_sellingUnit          = document.createElement('label');
  select_sellingUnit         = document.createElement('select');

  div_price                  = document.createElement('div');
  div_priceText              = document.createElement('div');
  span_priceTextName         = document.createElement('span');
  span_priceTextDate         = document.createElement('span');
  ins_priceNew               = document.createElement('ins');
  span_priceNewCur           = document.createElement('span');
  span_priceNewPrice         = document.createElement('span');
  span_priceNewUnit          = document.createElement('span');
  del_priceOld               = document.createElement('del');
  span_priceOldCur           = document.createElement('span');
  span_priceOldPrice         = document.createElement('span');
  span_priceOldUnit          = document.createElement('span');
  div_sellingUnitPrice       = document.createElement('div');
  span_sellingUnitPriceCa    = document.createElement('span');
  span_sellingUnitPriceCur   = document.createElement('span');
  span_sellingUnitPricePrice = document.createElement('span');
  span_sellingUnitPriceUnit  = document.createElement('span');

  div_summary                = document.createElement('div');
  div_summaryPiece           = document.createElement('div');
  div_summaryAmount          = document.createElement('div');
  div_summaryAmountKg        = document.createElement('div');
  div_summarySum             = document.createElement('div');
  span_summarySumCa          = document.createElement('span');
  span_summarySumCur         = document.createElement('span');
  span_summarySumValue       = document.createElement('span');
  steppedFreeOption          = document.createElement('option');    

  product               : ProductData;
  item                  : OrderListItem;
  hasFreeWeightPerPiece : boolean;
  parentObj             : DateFieldTop;
  context               : 'single-product' | 'order-list' | 'cart';
  platter               : cProductItemPlatter | null = null; // nur bei einer Platte

  constructor(
    item      : OrderListItem,
    product   : ProductData,
    parent    : HTMLElement,
    parentObj : DateFieldTop,
    context   : 'single-product' | 'order-list' | 'cart'
  ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.product   = product;
    this.item      = item;
    this.parentObj = parentObj;
    this.context   = context;

    this.hasFreeWeightPerPiece = 
      product.amounts.priceUnit === 'Kg' &&
      product.amounts.inputType === 1;


    // ---- Structure ----
    parent.append(this.fieldset_amount);
      this.fieldset_amount.append(this.label_amount);
      this.fieldset_amount.append(this.div_amount_wrapper);
        this.div_amount_wrapper.append(this.input_amount);
        this.div_amount_wrapper.append(this.span_amount);
      this.fieldset_amount.append(this.div_amount_error);

    parent.append(this.fieldset_amountSelect);
      this.fieldset_amountSelect.append(this.label_amountSelect);
      this.fieldset_amountSelect.append(this.select_amountSelect);
      this.fieldset_amountSelect.append(this.div_amountSelect_error);

      for(const optionData of this.getAmountOptions(this.item)) {
        const option       = document.createElement('option');
        option.value       = optionData.value;
        option.textContent = optionData.text;
        option.selected    = optionData.selected
        this.select_amountSelect.append(option);
      }

    parent.append(this.fieldset_weightPerPiece);
      this.fieldset_weightPerPiece.append(this.label_weightPerPiece);
      this.fieldset_weightPerPiece.append(this.div_weightPerPiece_wrapper);
        this.div_weightPerPiece_wrapper.append(this.input_weightPerPiece);
        this.div_weightPerPiece_wrapper.append(this.span_weightPerPiece);
      this.fieldset_weightPerPiece.append(this.div_weightPerPiece_error);

    parent.append(this.fieldset_sellingUnit);
      this.fieldset_sellingUnit.append(this.label_sellingUnit);
      this.fieldset_sellingUnit.append(this.select_sellingUnit);

      for(const unit of this.getSellingUnitOptions(this.item)) {
        const option       = document.createElement('option');
        option.value       = unit.value;
        option.textContent = unit.text;
        option.selected    = unit.selected
        this.select_sellingUnit.append(option);
      }

    // Eine Platte: Menge und Preis kommen aus der Auswahl der Komponenten
    if (product.platter.length > 0) {
      this.platter = new cProductItemPlatter(item, product, parent, this, context);
    }

    parent.append(this.div_price);
      this.div_price.append(this.div_priceText);
        this.div_priceText.append(this.span_priceTextName);
        this.div_priceText.append(this.span_priceTextDate);
      this.div_price.append(this.del_priceOld);
        this.del_priceOld.append(this.span_priceOldCur);
        this.del_priceOld.append(this.span_priceOldPrice);
        this.del_priceOld.append(this.span_priceOldUnit);
      this.div_price.append(this.ins_priceNew);
        this.ins_priceNew.append(this.span_priceNewCur);
        this.ins_priceNew.append(this.span_priceNewPrice);
        this.ins_priceNew.append(this.span_priceNewUnit);
      this.div_price.append(this.div_sellingUnitPrice);
        this.div_sellingUnitPrice.append(this.span_sellingUnitPriceCa);
        this.div_sellingUnitPrice.append(this.span_sellingUnitPriceCur);
        this.div_sellingUnitPrice.append(this.span_sellingUnitPricePrice);
        this.div_sellingUnitPrice.append(this.span_sellingUnitPriceUnit);

    parent.append(this.div_summaryPiece);
    parent.append(this.div_summary)
      this.div_summary.append(this.div_summaryAmount);
      this.div_summary.append(this.div_summaryAmountKg);
      this.div_summary.append(this.div_summarySum);
        this.div_summarySum.append(this.span_summarySumCa);
        this.div_summarySum.append(this.span_summarySumCur),
        this.div_summarySum.append(this.span_summarySumValue);
        
    // ---- Label Ids ----
    cUtil.labelIds(this.label_sellingUnit   , this.select_sellingUnit);
    cUtil.labelIds(this.label_amount        , this.input_amount);
    cUtil.labelIds(this.label_amountSelect  , this.select_amountSelect);
    cUtil.labelIds(this.label_weightPerPiece, this.input_weightPerPiece);

    // ---- Classes ----
    this.css('fieldset_amountSelect');
    this.css('fieldset_weightPerPiece');
    this.css('fieldset_amount');
    this.css('fieldset_sellingUnit');

    this.css('div_price');
    this.css('div_priceText');
    this.css('span_priceTextName');
    this.css('span_priceTextDate');
    this.css('ins_priceNew');
    this.css('span_priceNewCur');
    this.css('span_priceNewPrice');
    this.css('span_priceNewUnit');
    this.css('del_priceOld');
    this.css('span_priceOldCur');
    this.css('span_priceOldPrice');
    this.css('span_priceOldUnit');
    this.css('div_sellingUnitPrice');
    this.css('span_sellingUnitPriceCur');
    this.css('span_sellingUnitPricePrice');
    this.css('span_sellingUnitPriceUnit');

    this.css('div_summary');
    this.css('div_summaryPiece');
    this.css('div_summaryAmount');
    this.css('div_summaryAmountKg');
    this.css('div_summarySum');
    this.css('span_summarySumCa');
    this.css('span_summarySumCur');
    this.css('span_summarySumValue');

    //  ---- Texts ----
    this.label_sellingUnit.textContent    = __('Bestelleinheit', 'custom');
    this.label_amount.textContent         = __('Anzahl'        , 'custom');
    this.label_amountSelect.textContent   = __('Menge'         , 'custom');
    this.label_weightPerPiece.textContent = __('Sückgewicht'   , 'custom');

    // ---- Other ----
    this.input_amount         .type = 'text';
    this.input_weightPerPiece .type = 'text';

    // ---- Events ----
    this.select_sellingUnit.addEventListener('change', () => {
      this.changeSellingUnit();
      this.parentObj.changeEvent('cProductItemAmounts_change');
    });

    this.input_amount.addEventListener('keyup', () => {
      this.validateAmount();
      const amountData = this.calculateAmounts();
      this.displayAmounts(amountData);
      this.parentObj.changeEvent('cProductItemAmounts_change');
    });

    this.select_amountSelect.addEventListener('change', () => {
      if (this.select_amountSelect.value === '--other--') {
        this.select_amountSelect.value = '0';
        this.selectSteppedFree();
        this.changeSellingUnit();
      }
      const amountData = this.calculateAmounts();
      this.displayAmounts(amountData);
      this.parentObj.changeEvent('cProductItemAmounts_change');
    });

    this.input_weightPerPiece.addEventListener('keyup', () => {
      this.validateWeightPerPieceInt();
      const amountData = this.calculateAmounts();
      this.displayAmounts(amountData);
      this.parentObj.changeEvent('cProductItemAmounts_change');
    });
 
    // ---- Init ----
    if (product.amounts.sellingUnits.length <= 1 || this.hasFreeWeightPerPiece || this.platter !== null) 
      this.fieldset_sellingUnit.classList.add('c-hidden');

    if (!this.hasFreeWeightPerPiece) 
      this.fieldset_weightPerPiece.classList.add('c-hidden');

    this.input_amount.value = 
      item.amount === 0
      ? ''
      : String(item.amount);

    this.input_weightPerPiece.value = 
      item.weight_per_piece === 0
      ? String(this.product.weightPerPieceStandard * 1000)
      : String(item.weight_per_piece);

    this.changeSellingUnit();
  }

  getSellingUnitOptions(item: OrderListItem) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const options: {value: string, text: string, selected: boolean}[] = [];

    for(const unit of this.product.amounts.sellingUnits) {
      const priceObj  = getPrice(this.item.delivery_date, 'effective', this.product.amounts.prices);
      const price     = priceObj.price;
      const priceUnit = this.product.amounts.priceUnit;
      const kg        = __('Kg', 'custom');  


      if (unit.code === 'kg-stepped' && priceUnit === 'Kg') {
        const quantity = Number(this.product.amounts.nettoWeight);
        // const priceStr = (quantity * price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${kg} (${quantity} ${kg} / CHF ${priceStr})`,
          text     : `${kg} (${quantity} ${kg})`,
          selected : unit.code === item.selling_unit,
        });
      }

      else if (unit.code === 'kg-stepped' && priceUnit !== 'Kg') {
        const quantity = Number(this.product.amounts.nettoWeight);
        // const priceStr = (price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${kg} (${quantity} ${kg} / CHF ${priceStr})`,
          text     : `${kg} (${quantity} ${kg})`,
          selected : unit.code === item.selling_unit,
        });
      }

      else if (unit.code === 'Kg' && priceUnit === 'Kg') {
        // const priceStr = (price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${kg} (CHF ${priceStr})`,
          text     : `${kg}`,
          selected : unit.code === item.selling_unit,
        });
      }

      else if (unit.code === 'Kg' && priceUnit !== 'Kg') {
        const priceUnitLabel = __(priceUnit, 'custom');
        const quantity       = Number(this.product.amounts.nettoWeight);
        const priceStr       = (1/quantity * price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${kg} (1 ${kg} / CHF ${priceStr})`,
          text     : `${kg} (1 ${kg})`,
          selected : unit.code === item.selling_unit,
        });
      }

      else if (unit.code === priceUnit && unit.quantity === 1) {
        const unitCodeLabel = __(unit.code, 'custom');
        // const priceStr      = (price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${unitCodeLabel} (CHF ${priceStr})`,
          text     : `${unitCodeLabel}`,
          selected : unit.code === item.selling_unit,
        });
      }

      else {
        const unitCodeLabel  = __(unit.code, 'custom');  
        const priceUnitLabel = __(priceUnit, 'custom');
        // const priceStr       = (Number(unit.quantity) * price).toFixed(2);

        options.push({
          value    : unit.code,
          // text     : `${unitCodeLabel} (${unit.quantity} ${priceUnitLabel} / CHF ${priceStr})`,
          text     : `${unitCodeLabel} (${unit.quantity} ${priceUnitLabel})`,
          selected : unit.code === item.selling_unit,
        });
      }
    }

    const optionsSort = options.sort((a, b) => a.value === 'Kg' ? 1 : -1);

    return optionsSort;
  }

  getAmountOptions(item: OrderListItem) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const options: {value: string, text: string, selected: boolean}[] = [];

    for (const index of Array(10).keys()) {
      const value = index * this.product.amounts.nettoWeight;
      const valueRound = Math.round(value * 1000) / 1000;

      options.push({
        value    : String(index),
        text     : String(valueRound) + ' kg',
        selected : index === item.amount_select,
      });
    }
    options.push({
      value    : '--other--',
      text     : __('Individuell', 'custom'),
      selected : false,
    });

    const hasSelectedOption = options.find(option => option.selected === true);
    if (hasSelectedOption === undefined) {
      const firstOption = options.find(option => option.value === '0')
      if (firstOption !== undefined) {
        firstOption.selected = true;
      }
    }

    return options;
  }

  selectSteppedFree() {
    this.select_sellingUnit.value = 'Kg';
  }

  changeSellingUnit() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const currentSellingUnit = 
      this.product.amounts.sellingUnits
      .filter(unit => unit.code === this.select_sellingUnit.value)
      .find(su => su !== undefined);

    // Amounts
    if (this.platter !== null) {
      this.fieldset_amount       .classList.add('c-hidden');
      this.fieldset_amountSelect .classList.add('c-hidden');
    }
    else if (this.hasFreeWeightPerPiece) {
      this.fieldset_amount       .classList.remove('c-hidden');
      this.fieldset_amountSelect .classList.add('c-hidden');
      this.span_amount.textContent = 'St'
    }
    else if (currentSellingUnit !== undefined && currentSellingUnit.amountType === 'stepped') {
      this.fieldset_amount       .classList.add('c-hidden');
      this.fieldset_amountSelect .classList.remove('c-hidden');
      this.span_amount.textContent = __(this.select_sellingUnit.value, 'custom');
    }
    else {
      this.fieldset_amount       .classList.remove('c-hidden');
      this.fieldset_amountSelect .classList.add('c-hidden');
      this.span_amount.textContent =__(this.select_sellingUnit.value, 'custom');

      if (this.select_sellingUnit.value === 'Kg') this.label_amount.textContent = __('Menge'  , 'custom');
      if (this.select_sellingUnit.value === 'St') this.label_amount.textContent = __('Anzahl' , 'custom');
    }

    // Weight per piece
    this.span_weightPerPiece.textContent = 
      this.hasFreeWeightPerPiece 
      ? __('g/St', 'custom') 
      : `${__(this.product.amounts.priceUnit, 'custom')}/${__(this.select_sellingUnit.value, 'custom')}`;

    const amountData = this.calculateAmounts();
    this.displayAmounts(amountData);
  }


  calculateAmounts(): AmountDataFull {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const activeUnit = this.getActiveUnit();

    // The following functions must be compatible with \c\singleProduct\Amounts\input(...)
    const priceUnitLabel   = __(this.product.amounts.priceUnit , 'custom');
    const sellingUnitLabel = __(activeUnit.code                , 'custom');
    const per              = __('per'                          , 'custom');
    const St               = __('St'                           , 'custom');

    __('BT' , 'custom');
    __('EH' , 'custom');
    __('K'  , 'custom');
    __('Ke' , 'custom');
    __('Lt' , 'custom');
    __('Pa' , 'custom');
    __('PAK', 'custom');
    __('SCH', 'custom');
    __('Kg' , 'custom');
    
    const weightPerPice = Number.isNaN(Number(this.input_weightPerPiece.value )) ? 0 : Number(this.input_weightPerPiece.value );
    const amount        = Number.isNaN(Number(this.input_amount.value         )) ? 0 : Number(this.input_amount.value         );
    const amountSelect  = Number.isNaN(Number(this.select_amountSelect.value  )) ? 0 : Number(this.select_amountSelect.value  );

    const priceObj     = getPrice(this.item.delivery_date, 'effective', this.product.amounts.prices);
    const origPriceObj = getPrice(this.item.delivery_date, 'regular', this.product.amounts.prices);

    const amountData : AmountDataFull = {
      price                 : priceObj.price,
      priceLabel            : __(this.product.amounts.priceUnit , 'custom'),
      origPrice             : priceObj.isOnSale ? origPriceObj.price : 0.0,
      isOnSale              : priceObj.isOnSale,
      isIndvidualPrice      : priceObj.isIndvidualPrice,
      priceToDate           : priceObj.toDate,
      sellingUnitCode       : activeUnit?.code ?? '',
      amount                : 0.0,
      amountLabel           : '',
      weightPerPiece        : 0.0,
      weightPerPieceLabel   : '',
      totalAmount           : 0.0,
      totalAmountLabel      : '',
      totalAmountKg         : 0.0,
      sellingUnitPrice      : 0.0,
      sellingUnitPriceLabel : '',
      totalPrice            : 0.0,
    }

    // Must be compatible with \c\Platter\amounts(). Eine Platte ist ein Stück zum Stückpreis, ohne
    // Auswahl mit Menge 0. Den Durchschnitt pro Kg zeigt displayAmounts() aus platter.calculate().
    if (this.platter !== null) {
      const platterPrice               = this.platter.calculate();
      const amount                     = platterPrice.totalKg > 0 ? 1 : 0;
      amountData.price                 = platterPrice.total;
      amountData.priceLabel            = St;
      amountData.origPrice             = 0.0;
      amountData.isOnSale              = false;
      amountData.isIndvidualPrice      = false;
      amountData.priceToDate           = '';
      amountData.amount                = amount;
      amountData.amountLabel           = St;
      amountData.totalAmount           = amount;
      amountData.totalAmountLabel      = St;
      amountData.totalAmountKg         = platterPrice.totalKg;
      amountData.totalPrice            = amount * platterPrice.total;
      amountData.sellingUnitPrice      = platterPrice.average / 10;
      amountData.sellingUnitPriceLabel = '100g';
    }
    else if (this.product.amounts.inputType === 1) {
      amountData.amount                = amount;
      amountData.amountLabel           = St;
      amountData.weightPerPiece        = weightPerPice;
      amountData.weightPerPieceLabel   = `g ${per} ${St}`;
      amountData.totalAmount           = amount * weightPerPice / 1000;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount * weightPerPice / 1000;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 0.0;
      amountData.sellingUnitPriceLabel = 'Kg';
    }
    else if (activeUnit.code === 'kg-stepped' && this.product.amounts.priceUnit === 'Kg') {
      amountData.amount                = amountSelect * this.product.amounts.nettoWeight;
      amountData.amountLabel           = 'Kg';
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = 'Kg';
      amountData.totalAmount           = amountSelect * this.product.amounts.nettoWeight;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amountSelect * this.product.amounts.nettoWeight;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 0.0;
      amountData.sellingUnitPriceLabel = 'Kg';
    }
    else if (activeUnit.code === 'kg-stepped' && this.product.amounts.priceUnit !== 'Kg') {
      const quantity                   = Number(this.product.amounts.nettoWeight);
      amountData.amount                = amountSelect * this.product.amounts.nettoWeight;
      amountData.amountLabel           = 'Kg';
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = `Kg ${per} ${priceUnitLabel}`;
      amountData.totalAmount           = amountSelect;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amountSelect * this.product.amounts.nettoWeight;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 1/this.product.amounts.nettoWeight * amountData.price;
      amountData.sellingUnitPriceLabel = 'Kg';
    }
    else if (activeUnit.code === 'Kg' && this.product.amounts.priceUnit === 'Kg') {
      amountData.amount                = amount;
      amountData.amountLabel           = 'Kg';
      amountData.weightPerPiece        = 0.0;
      amountData.weightPerPieceLabel   = '';
      amountData.totalAmount           = amount;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 0.0;
      amountData.sellingUnitPriceLabel = 'Kg';
    }
    else if (activeUnit.code === 'Kg' && this.product.amounts.priceUnit !== 'Kg') {
      amountData.amount                = amount;
      amountData.amountLabel           = 'Kg';
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = `Kg ${per} ${priceUnitLabel}`;
      amountData.totalAmount           = amount / this.product.amounts.nettoWeight;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 1/this.product.amounts.nettoWeight * amountData.price;
      amountData.sellingUnitPriceLabel = 'Kg';
    }
    else if (activeUnit.code !== 'Kg' && this.product.amounts.priceUnit === 'Kg') {
      amountData.amount                = amount;
      amountData.amountLabel           = activeUnit.code;
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = `Kg ${per} ${sellingUnitLabel}`;
      amountData.totalAmount           = amount * this.product.amounts.nettoWeight;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount * this.product.amounts.nettoWeight;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = this.product.amounts.nettoWeight * amountData.price;
      amountData.sellingUnitPriceLabel = __(activeUnit.code, 'custom');
    }
    else if (activeUnit.code === this.product.amounts.priceUnit) {
      amountData.amount                = amount;
      amountData.amountLabel           = activeUnit.code;
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = `Kg ${per} ${priceUnitLabel}`;
      amountData.totalAmount           = amount;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount * this.product.amounts.nettoWeight;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = 0.0;
      amountData.sellingUnitPriceLabel = __(activeUnit.code, 'custom');
    }
    else {
      amountData.amount                = amount;
      amountData.amountLabel           = activeUnit.code;
      amountData.weightPerPiece        = this.product.amounts.nettoWeight;
      amountData.weightPerPieceLabel   = `Kg ${per} ${sellingUnitLabel}`;
      amountData.totalAmount           = Number(activeUnit.quantity) * amount;
      amountData.totalAmountLabel      = amountData.priceLabel;
      amountData.totalAmountKg         = amount * this.product.amounts.nettoWeight;
      amountData.totalPrice            = amountData.totalAmount * amountData.price;
      amountData.sellingUnitPrice      = activeUnit.quantity * amountData.price;
      amountData.sellingUnitPriceLabel = __(activeUnit.code, 'custom');
    }

    return amountData;
  }

  displayAmounts(amountData : AmountDataFull): void {
    // The following functions must be compatible with \c\OrderItem\ woocommerce_get_item_data
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const activeUnit  = this.getActiveUnit();
    const date        = cUtil.isoToCh(amountData.priceToDate);
    const caPrice     = amountData.totalPrice     === 0 ? '' : 'ca. ';
    const caPiece     = amountData.weightPerPiece === 0 ? '' : 'ca. ';
    const amountStrKg = `${caPrice}${amountData.totalAmountKg.toFixed(3)} Kg`;
    const pieceStr    = 
      amountData.weightPerPiece !== 0.0
      ? `${caPiece}${String(amountData.weightPerPiece)} ${amountData.weightPerPieceLabel}`
      : '';

    const dateStr = 
      (date !== '01.01.1970') && (date !== '31.12.9999')
      ? ' ' + __('bis', 'custom') + ' ' + date
      : '';

    const showSellingUnitPrice =
      amountData.sellingUnitPrice !== 0.0 &&
      (activeUnit.code === 'Kg' || this.product.amounts.priceUnit === 'Kg' || activeUnit.quantity !== 1)

    if (showSellingUnitPrice) {
      this.div_sellingUnitPrice       .style.display = 'block';
      this.span_sellingUnitPriceCur   .textContent = 'CHF';
      this.span_sellingUnitPricePrice .textContent = amountData.sellingUnitPrice.toFixed(2);
      this.span_sellingUnitPriceUnit  .textContent = ' / ' + amountData.sellingUnitPriceLabel;
      this.span_sellingUnitPriceCa    .style.display = 'inline';
    }
    else {
      this.div_sellingUnitPrice.style.display = 'none';
    }

    this.span_priceNewCur   .textContent = 'CHF';
    this.span_priceNewPrice .textContent = amountData.price.toFixed(2);
    this.span_priceNewUnit  .textContent = ' / ' + amountData.priceLabel;
    
    this.div_price.classList.remove('c-individual-price');
    this.div_price.classList.remove('c-offer');
    this.div_price.classList.remove('c-normal');

    if (amountData.isIndvidualPrice) {
      this.div_price          .classList.add('c-individual-price');
      this.div_priceText      .classList.remove('c-hidden');
      this.span_priceTextName .textContent     = __('Offerte', 'custom');
      this.span_priceTextDate .textContent     = dateStr;
      this.del_priceOld       .style.display   = 'none';
    }
    else if (amountData.isOnSale) {
      this.div_price          .classList.add('c-offer');
      this.div_priceText      .classList.remove('c-hidden');
      this.span_priceTextName .textContent     = __('Angebot', 'custom');
      this.span_priceTextDate .textContent     = dateStr;
      this.span_priceOldCur   .textContent     = 'CHF';
      this.span_priceOldPrice .textContent     = amountData.origPrice.toFixed(2);
      this.span_priceOldUnit  .textContent     = ' / ' + amountData.priceLabel;
      this.del_priceOld       .style.display   = 'block';
    }
    else {
      this.div_price          .classList.add('c-normal');
      this.div_priceText      .classList.add('c-hidden');
      this.span_priceTextName .textContent     = '';
      this.span_priceTextDate .textContent     = '';
      this.del_priceOld       .style.display   = 'none';
    }

    this.span_summarySumCur .textContent = 'CHF';

    // Platte: oben der Durchschnitt des Fleisches pro Kg statt des Stückpreises, unten die
    // Gesamtmenge in Kg und der Warenwert. Der Warenwert ohne "ca.", die Platte hat einen Festpreis.
    if (this.platter !== null) {
      const kg = __('Kg', 'custom');
      this.span_priceNewPrice   .textContent = this.platter.calculate().average.toFixed(2);
      this.span_priceNewUnit    .textContent = ' / ' + kg;
      this.div_summaryPiece     .textContent = '';
      this.div_summaryAmount    .textContent = '';
      this.div_summaryAmountKg  .textContent = `${caPrice}${amountData.totalAmountKg.toFixed(3)} ${kg}`;
      this.span_summarySumCa    .textContent = '';
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    // see also single-product pdf
    else if (this.product.amounts.inputType === 1) {
      this.div_summaryPiece     .textContent = '';
      this.div_summaryAmount    .textContent = '';
      this.div_summaryAmountKg  .textContent = amountStrKg;
      this.span_summarySumCa    .textContent = caPrice;
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code === 'kg-stepped' && this.product.amounts.priceUnit === 'Kg') {
      this.div_summaryPiece     .textContent = '';
      this.div_summaryAmount    .textContent = `${amountData.totalAmount.toFixed(3)} ${amountData.totalAmountLabel}`;
      this.div_summaryAmountKg  .textContent = amountStrKg;
      this.span_summarySumCa    .textContent = '';
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code === 'kg-stepped' && this.product.amounts.priceUnit !== 'Kg') {
      this.div_summaryPiece     .textContent = pieceStr;
      this.div_summaryAmount    .textContent = `${caPrice}${amountData.totalAmount.toFixed(3)} ${amountData.totalAmountLabel}`;
      this.div_summaryAmountKg  .textContent = amountStrKg;
      this.span_summarySumCa    .textContent = caPrice;
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code === 'Kg' && this.product.amounts.priceUnit === 'Kg') {
      this.div_summaryPiece     .textContent = '';
      this.div_summaryAmount    .textContent = '';
      this.div_summaryAmountKg  .textContent = amountStrKg;
      this.span_summarySumCa    .textContent = caPrice;
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code === 'Kg' && this.product.amounts.priceUnit !== 'Kg') {
      this.span_sellingUnitPriceCa .textContent = 'ca. ';
      this.div_summaryPiece        .textContent = pieceStr;
      this.div_summaryAmount       .textContent = `${caPrice}${amountData.totalAmount.toFixed(0)} ${amountData.totalAmountLabel}`;
      this.div_summaryAmountKg     .textContent = amountStrKg;
      this.span_summarySumCa       .textContent = caPrice;
      this.span_summarySumValue    .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code !== 'Kg' && this.product.amounts.priceUnit === 'Kg') {
      this.span_sellingUnitPriceCa .textContent = 'ca. ';
      this.div_summaryPiece        .textContent = pieceStr;
      this.div_summaryAmount       .textContent = '';
      this.div_summaryAmountKg     .textContent = amountStrKg;
      this.span_summarySumCa       .textContent = caPrice;
      this.span_summarySumValue    .textContent = amountData.totalPrice.toFixed(2);
    }
    else if (activeUnit.code === this.product.amounts.priceUnit) {
      this.div_summaryPiece     .textContent = pieceStr;
      this.div_summaryAmount    .textContent = '';
      this.div_summaryAmountKg  .textContent = amountData.totalAmountKg !== 0.0 ? amountStrKg : '';
      this.span_summarySumCa    .textContent = '';
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    }
    else  {
      this.div_summaryPiece     .textContent = pieceStr;
      this.div_summaryAmount    .textContent = activeUnit.quantity !== 1 ? `${amountData.totalAmount.toFixed(3)} ${amountData.totalAmountLabel}` : '';
      this.div_summaryAmountKg  .textContent = amountData.totalAmountKg !== 0.0 ? amountStrKg : '';
      this.span_summarySumCa    .textContent = '';
      this.span_summarySumValue .textContent = amountData.totalPrice.toFixed(2);
    } 
  }

  getActiveUnit(): SellingUnitExt  {
    let activeUnit = 
      this.product.amounts.sellingUnits
      .filter(unit => unit.code === this.select_sellingUnit.value)
      .find(su => su !== undefined);

    if (activeUnit === undefined) {
      activeUnit = {
        id         : 0,
        code       : 'Error',
        quantity   : 1,
        amountType : 'integer'
      };
    }
    return activeUnit;
  }

  isEmpty() {
    if (this.platter !== null) return this.platter.isEmpty();

    const currentSellingUnit = 
      this.product.amounts.sellingUnits
      .filter(unit => unit.code === this.select_sellingUnit.value)
      .find(su => su !== undefined);
    const value =
      this.hasFreeWeightPerPiece                                                      ? this.input_amount.value        : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'stepped' ? this.select_amountSelect.value : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'integer' ? this.input_amount.value        : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'float'   ? this.input_amount.value        : 
      '0';

    const isEmpty = 
      value === '' || Number(value) === 0;

    return isEmpty;
  }

  getAmounts() {
    const amountData = this.calculateAmounts();
    const totalPrice = amountData.totalAmount * amountData.price;
    return totalPrice;
  }

  getWeight() {
    const amountData = this.calculateAmounts();
    return amountData.totalAmountKg;
  }

  changeEvent(eventSource: string): void {
    if (eventSource === 'cProductItemPlatter_change') {
      this.validateAmount();
      const amountData = this.calculateAmounts();
      this.displayAmounts(amountData);
      this.parentObj.changeEvent('cProductItemAmounts_change');
      return;
    }
    this.parentObj.changeEvent(eventSource);
  }

  validateItem(silent: 'silent'|'', deliveryDate: string, isSelected: boolean = true): boolean {
    this.item.delivery_date = deliveryDate;
    this.platter?.update(deliveryDate);
    const amounts = this.calculateAmounts();
    this.displayAmounts(amounts);

    if (isSelected) {
      let amountInt         = this.validateAmount(silent);
      let weightPerPieceInt = this.validateWeightPerPieceInt(silent);
      return amountInt && weightPerPieceInt;
    }
    return true;
  }


  validateAmount(silent: 'silent'|'' = ''): boolean {
    if (this.platter !== null) return this.platter.validate(silent);

    const currentSellingUnit = 
      this.product.amounts.sellingUnits
      .filter(unit => unit.code === this.select_sellingUnit.value)
      [0];

    const result = 
      this.hasFreeWeightPerPiece                                                      ? this.validateAmountInt(silent)    : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'stepped' ? this.validateAmountSelect(silent) : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'integer' ? this.validateAmountInt(silent)    : 
      currentSellingUnit !== undefined && currentSellingUnit.amountType === 'float'   ? this.validateAmountFloat(silent)  : 
      false;
  
    return result;
  }

  validateAmountInt(silent: 'silent'|'' = ''): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const format   = /^\s*[0-9]*\s*$/;
    const value    = this.input_amount.value;
    const isNumber = format.test(value);
    const isEmpty  = this.context !== 'order-list' && (value === '' || Number(value) === 0);

    const errorMsg = 
      isEmpty   ? __('Bitte geben sie eine Stückzahl ein.', 'custom') : 
      !isNumber ? __('Kein gültiges Zahlenformat für die Stückzahl.', 'custom') : 
      /*else*/    '';

    const hasError = errorMsg.length > 0;

    if (silent !== 'silent' && hasError) {
      this.div_amount_error.textContent = errorMsg;
      this.div_amount_error.classList.add('c--error');
      this.div_amount_wrapper.classList.add('c--error-marker');
    }
    else {
      this.div_amount_error.textContent = '';
      this.div_amount_error.classList.remove('c--error');
      this.div_amount_wrapper.classList.remove('c--error-marker');
    }
  
    return !hasError;
  }

  validateAmountFloat(silent: 'silent'|'' = ''): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const format       = /^\s*[0-9]*\.?[0-9]?[0-9]?[0-9]?\s*$/;
    const value        = this.input_amount.value;
    const isNumber     = format.test(value);
    const isEmpty      = this.context !== 'order-list' && (value === '' || Number(value) === 0);
    const minWeight    = this.product.amounts.nettoWeight;
    const hasMinWeight = Number(this.input_amount.value) >= minWeight || this.input_amount.value === '';

    const errorMsg = 
      isEmpty       ? __('Bitte geben sie eine Menge ein.', 'custom')              : 
      !isNumber     ? __('Kein gültiges Zahlenformat für die Menge.', 'custom')                   :
      !hasMinWeight ? __('Das Mindestgewicht beträgt ', 'custom') + String(minWeight.toFixed(3)) + ' Kg.' :  
      /*else*/ '';

      const hasError = errorMsg.length > 0;

      if (silent !== 'silent' && hasError) {
        this.div_amount_error.textContent = errorMsg;
        this.div_amount_error.classList.add('c--error');
        this.div_amount_wrapper.classList.add('c--error-marker');
      }
      else { 
        this.div_amount_error.textContent = '';
        this.div_amount_error.classList.remove('c--error');
        this.div_amount_wrapper.classList.remove('c--error-marker');
      }

    return !hasError;
  }

  validateAmountSelect(silent: 'silent'|'' = ''): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const format   = /^\s*[0-9]*\.?[0-9]?[0-9]?[0-9]?\s*$/;
    const value    = this.select_amountSelect.value;
    const isNumber = format.test(value);
    const isEmpty  = this.context !== 'order-list' && (value === '' || Number(value) === 0);

    const errorMsg = 
      isEmpty   ? __('Bitte geben sie eine Menge ein.', 'custom') : 
      !isNumber ? __('Kein gültiges Zahlenformat für die Menge.', 'custom') : 
      /*else*/    '';

      const hasError = errorMsg.length > 0;

      if (silent !== 'silent' && hasError) {
        this.div_amountSelect_error.textContent = errorMsg;
        this.div_amountSelect_error.classList.add('c--error');
        this.select_amountSelect.classList.add('c--error-marker');
      }
      else { 
        this.div_amountSelect_error.textContent = '';
        this.div_amountSelect_error.classList.remove('c--error');
        this.select_amountSelect.classList.remove('c--error-marker');
      }

    return !hasError;
  }



  validateWeightPerPieceInt(silent: 'silent'|'' = ''): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    if (!this.hasFreeWeightPerPiece) return true;

    const typical = this.product.weightPerPieceStandard * 1000;
    const range   = this.product.weightPerPieceRange;

    const format   = /^\s*[0-9]*\s*$/;
    const value    = this.input_weightPerPiece.value;
    const isNumber = format.test(value);
    const isEmpty  = value === '' || Number(value) === 0;

    let min = Math.ceil(typical * (100 - range) / 100);
    let max = Math.floor(typical * (100 + range) / 100);

    if (typical >= 50) {
      min = Math.ceil(min / 10) * 10;
      max = Math.floor(max / 10) * 10;
    }

    const isNotInRange = Number(value) > max || Number(value) < min;


    const errorMsg = 
      isEmpty      ? __('Bitte geben sie ein Gewicht ein.', 'custom')  : 
      !isNumber    ? __('Kein gültiges Zahlenformat für das Gewicht.', 'custom')           : 
      isNotInRange ? __('Wert ausserhalb des gültigen Bereichs ', 'custom') + `(${String(min)}g - ${String(max)}g)`:
      /*else*/    '';

    const hasError = errorMsg.length > 0;

    if (silent !== 'silent' && hasError) {
      this.div_weightPerPiece_error.textContent = errorMsg;
      this.div_weightPerPiece_error.classList.add('c--error');
      this.div_weightPerPiece_wrapper.classList.add('c--error-marker');
    }
    else { 
      this.div_weightPerPiece_error.textContent = '';
      this.div_weightPerPiece_error.classList.remove('c--error');
      this.div_weightPerPiece_wrapper.classList.remove('c--error-marker');
    }

    return !hasError;
  }

  getData() {
    const output = {
      selling_unit     : this.select_sellingUnit.value,
      amount           : Number(this.input_amount.value),
      amount_select    : Number(this.select_amountSelect.value),
      weight_per_piece : Number(this.input_weightPerPiece.value),
      components       : this.platter?.getData() ?? '',
      arranged         : this.platter?.isArranged() ?? false,
    }
    return output;
  }

  css<K extends keyof cProductItemAmounts>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}
